import axios from "../../axios";
import { parseContentDispositionFilename } from "../../../utils/http";

const api = {
  getProductCategoriesPerLocation(params, accessToken) {
    const config = {
      params: params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/product-categories", config).then(({ data }) => {
      return data.map(item => {
        return {
          ...item,
          location: params.location
        }
      });
    });
  },

  getLocations(accessToken) {
    const config = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get("/product-locations", config).then(({ data }) => data);
  },

  getPurchasedProductItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/organization-questionnaires/${params.questionnaireId}/purchased-goods-and-services/items`,
      config).then(({ data }) => data);
  },

  addPurchasedProductItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/organization-questionnaires/${questionnaireId}/purchased-goods-and-services/items`, data, headers)
      .then(({ data }) => data);
  },

  updatePurchasedProductItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/organization-questionnaires/${questionnaireId}/purchased-goods-and-services/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deletePurchasedProductItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/organization-questionnaires/${questionnaireId}/purchased-goods-and-services/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importPurchasedProductItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/organization-questionnaires/${questionnaireId}/purchased-goods-and-services/items/import`, data, headers).then(({ data }) => data);
  },

  getTemplate(questionnaireId, accessToken) {
    const config = {
      responseType: "arraybuffer",
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(
      `/organization-questionnaires/${questionnaireId}/purchased-goods-and-services/items/template`, config
    ).then(({ data, headers }) => {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      const defaultFileName = parseContentDispositionFilename(
        headers["content-disposition"], "Scope3_Category1_template.xlsx");
      link.href = url;
      link.setAttribute("download", defaultFileName);
      document.body.appendChild(link);
      link.click();
      return true;
    });
  },
};



export default api;
